import en from './en.json';
import es from './es.json';

// String key is what how the Locales appear as result of localeLoader helper function.
export default {
  en,
  'es-MX': es,
};
